import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import { useNavigate } from "react-router-dom";
import { SETCARTCOUNT, SETCARTDATA, SETCARTTOTALPRICE, } from "../../redux/features/CartData";
import { CLEARVARIATIONDATA } from "../../redux/features/Variation";
import ParseFloat from "../../utils/ParseFloat";
import { SortVarition } from "../../utils/SortVariation";
import { TaxCalcualate } from "../../utils/TaxCalculate";
// import ItemTitleDetail from "../RightSideBar/ItemTitleDetail/ItemTitleDetail";
import ItemVariationView from "../RightSideBar/ItemVariationView/ItemVariationView";
import StepTitle from "../RightSideBar/StepTitle/StepTitle";
import StoreDescription from "../Store/Store-Description";
import AddOnData from "../RightSideBar/AddOnData/AddOnData";
import { refPageRoute } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import useMobile from "../../hooks/useMobile";
import useDeviceIos from "../../hooks/useDeviceIos";
import DescriptionMoreLess from "../Read-More/DescriptionMoreLess";
import GlobalButton from "../Buttons/btn2/GlobalButton";
import { isTaxInclusive } from "../../utils/helper";
import useCartData from "../../hooks/useCartData";
// import { GetItemPrice } from "../../utils/GetItemPrice";
interface customeType {
  onCloseModal?: any;
  taxdata?: any;
  menu_id?: any;
  refrencePage?: any
}
const VariationSelection = ({ refrencePage, onCloseModal, menu_id, taxdata, }: customeType) => {
  const {
    variationData,
    cartData: { itemCount, items },
  }: any = useSelector((state: any) => state);
  const { t } = useTranslation()
  const { CheckVariationItemExist } = useCartData()
  menu_id = refrencePage == refPageRoute ? variationData?.menu_id_for_page : menu_id;
  taxdata = refrencePage == refPageRoute ? variationData?.textdata_for_page : taxdata;

  const [selectData, setSelectData] = useState<any>();
  const [selectAddOn, setSelectedAddOn] = useState<any>([]);
  const [finalPrice, setFinalPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const mobile = useMobile();
  const device = useDeviceIos();

  useEffect(() => {
    if (variationData && Object.keys(variationData)?.length > 0) {
      setSelectData(SortVarition(variationData)?.item_variation[0]);
    } else {
      onCloseModal()
    }
    if (variationData.isEdit) {
      setSelectData(variationData?.selected_variation);
      setSelectedAddOn(variationData?.selected_addOn);
      setQuantity(variationData.quantity);
    }
  }, [variationData]);

  const variatiosAdd = async (data: any) => {
    if (CheckVariationItemExist(data, selectAddOn, quantity)) {
      handleCloseModel();
      return;
    }
    const finalData: any = [];


    const store_variation_price = variationData?.map_store_item_variation?.find((variation: any) => variation.variation_id === data.variation_id);
    data["web_price"] = parseFloat(store_variation_price ? store_variation_price?.offered_variation_price : data?.web_price);
    let price = parseFloat(store_variation_price ? store_variation_price?.offered_variation_price : data?.web_price) || 0;

    selectAddOn.map((data: any) => {
      price = price + parseFloat(data.web_offered_price ? data.web_offered_price : 0);
    });
    const TaxData = TaxCalcualate(taxdata, price * quantity, 1);
    const varData = structuredClone(variationData);
    varData["map_tax_class"] = taxdata.map_tax_class;
    varData["tax_class"] = taxdata.tax_class;
    varData["price"] = parseFloat(store_variation_price ? store_variation_price?.offered_variation_price : data?.web_price) || 0;
    varData["sub_total"] = price;
    varData["tax_rate_list"] = TaxData.taxArray;
    varData["selected_variation"] = data;

    varData["total_price"] = isTaxInclusive(TaxData.tax_inclusive_exclusive_type) ? Number(price * quantity) : Number(price * quantity) + TaxData.fixedTax + (Number(price * quantity) * TaxData.percentageTax) / 100;
    varData["selectedCategory"] = [];
    varData["selected_addOn"] = selectAddOn;
    varData['from_ad_on']=selectAddOn?.length>0 ? true:false
    varData["selectedoptions"] = [];
    varData["map_store_item_variation"] = variationData?.map_store_item_variation?.length > 0 ? variationData?.map_store_item_variation : [];

    varData["menu_id"] = menu_id;
    if (variationData.isEdit !== true) {
      varData["uniqueIndex"] = items ? items.length + 1 : 1;
    }

    finalData.push(varData);
    const previous = items;
    if (previous.length > 0) {
      if (variationData.isEdit) {
        const index = previous.findIndex((item: any) => item.uniqueIndex == varData.uniqueIndex);
        previous.splice(index, 1, varData);
        dispatch(SETCARTCOUNT(itemCount + (quantity - variationData.quantity)));
        varData["quantity"] = quantity;
      } else {
        previous.push(varData);
        dispatch(SETCARTCOUNT(itemCount + quantity));

        varData["quantity"] = quantity;
      }
      dispatch(SETCARTDATA(previous));
      let total = 0;
      previous.map((data: any) => {
        //(data)
        total = parseFloat(`${total}`) + (data.total_price ? parseFloat(data.total_price) : parseFloat(data.price));
      });

      dispatch(SETCARTTOTALPRICE(total));
      if (sessionStorage.getItem("backCheckout") == "1") {
        navigation("/checkout");
        sessionStorage.removeItem("backCheckout");
      }
    } else {
      varData["quantity"] = quantity;
      dispatch(SETCARTDATA(finalData));
      let total = 0;
      finalData?.map((data: any) => {
        //(data)
        total =
          parseFloat(`${total}`) +
          (data.total_price
            ? parseFloat(data.total_price)
            : parseFloat(data.price));
      });
      dispatch(SETCARTTOTALPRICE(total));
      dispatch(SETCARTCOUNT(itemCount + quantity));
      if (sessionStorage.getItem("backCheckout") == "1") {
        navigation("/checkout");
        sessionStorage.removeItem("backCheckout");
      }
    }
    handleCloseModel();
  };

  const handleCloseModel = () => {
    dispatch(CLEARVARIATIONDATA({}));
    setSelectData({});
    onCloseModalFun();
    if (sessionStorage.getItem("backCheckout") == "1") {
      navigation("/checkout");
      sessionStorage.removeItem("backCheckout");
    }
  }
  useEffect(() => {
    if (selectData) {
      let price = Number(selectData?.web_price || 0);
      selectAddOn?.map((item: any) => {
        price += Number(item.web_offered_price ? item.web_offered_price : 0);
      });
      setFinalPrice(price);
    }
  }, [selectData, selectAddOn]);

  const onCloseModalFun = () => {
    onCloseModal();
  }

  const imageUrl = useMemo(() => {
    let imgUrl = variationData?.item_attachment?.base_url + variationData?.item_attachment?.attachment_url;
    return imgUrl ? imgUrl : '/images/no_image_available.svg'
  }, [variationData])

  return (
    <>
      {/* <div className={(mobile && device ? "mt-16 relative md:h-[calc(100vh-7rem)] h-[calc(100vh-4rem)] scroll-hidden overflow-y-auto" :"relative md:h-[calc(100vh-7rem)] h-[calc(100vh-4rem)] scroll-hidden overflow-y-auto")}> */}
      <div className={"relative h-full overflow-y-auto scroll-hidden scroll-touch-screen"}>

        <div className="h-48 relative  ">
          <img src={imageUrl} className="absolute object-cover w-full h-full" />
        </div>
        <div className="flex justify-between items-center sticky top-0 bg-white md:px-8 px-3 py-3 z-50">
          {variationData?.name && (
            <h4 className="md:text-[2rem] text-xl font-normal font-splekta ">
              {variationData?.name}
            </h4>
          )}
          {/* <p className="text-[#4B4B4B] md:text-xl text-base font-bold">
            {ParseFloat(GetItemPrice(variationData))}
          </p> */}
        </div>
        <div className="md:px-8 px-3 pb-20 scroll-hidden pointer-events-auto touch-auto">

          {variationData?.description ? <DescriptionMoreLess text={variationData?.description} /> : ''}



          <hr className="border-b-2 border-[#ECECEC] my-2" />
          <div className="variationSection mb-2">
            <StepTitle stepTitle={t("Home.pleaseSelectVariations")} success={true} />


            {/* @@ Variation data map */}
            {selectData &&
              variationData?.item_variation.map((data: any, index: number) => {
                const store_variation_price = variationData?.map_store_item_variation?.find((variation: any) => variation.variation_id === data.variation_id);
                return (
                  <div key={index}>
                    <ItemVariationView
                      selectedId={selectData?.id}
                      price={
                        store_variation_price ? store_variation_price.offered_variation_price : data.web_price
                      }
                      id={data.id}
                      itemName={data?.variation_detail[0]?.variation_name}
                      onchange={() => setSelectData(data)}
                    />
                  </div>
                );
              })}

            {/* @@ Add On Data */}
            <AddOnData
              refrencePage={'VariationModal'}
              key={selectAddOn}
              selectAddOn={selectAddOn}
              setSelectedAddOn={setSelectedAddOn}
              addon_data={variationData?.addon_data}

            />

            <hr className="mb-2" />
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 w-full bg-white touch-auto pointer-events-auto md:px-8 px-3 py-4 border-t border-[#ECECEC]">
        <div className="flex justify-between">

          <div className="allCounterButton">
            <span className="rounded-full border border-gray-400 cursor-pointer p-2" onClick={() => setQuantity((pre) => (pre > 1 ? pre - 1 : pre))}>
              <svg width="12" height="12" viewBox="0 0 38 5" fill="currentColor">
                <path d="M36.7188 0H0.78125C0.292969 0 0 0.390625 0 0.78125V3.90625C0 4.39453 0.292969 4.6875 0.78125 4.6875H36.7188C37.1094 4.6875 37.5 4.39453 37.5 3.90625V0.78125C37.5 0.390625 37.1094 0 36.7188 0Z"></path>
              </svg>
            </span>

            <span className="prevent-select-disable">{quantity}</span>

            <span onClick={() => setQuantity((pre) => pre + 1)} className="rounded-full border border-gray-400  p-2 cursor-pointer"   >
              <svg width="12" height="12" viewBox="0 0 38 38" fill="currentColor">
                <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
              </svg>
            </span>
          </div>

          {/* <button onClick={() => variatiosAdd(selectData)} className="lg:w-1/2 inline-flex justify-center md:gap-14 btn-secondary !px-4 py-4">
            <div className="flex gap-3 prevent-select-disable">
              {t("Home.addToOrder")} - <span className="">{ParseFloat(quantity * finalPrice)}</span>
            </div>
          </button> */}

          <GlobalButton
            className='md:w-1/3 lg:w-1/3 xl:w-1/3'
            onClick={() => variatiosAdd(selectData)}
            label={`${t("Home.addToOrder")} ${"   -  "}${ParseFloat(quantity * finalPrice)}`} />
        </div>
      </div>
    </>
  );
};

export default VariationSelection;
